import { localizedErrorMessage } from '@/lib/i18n/errors';
import { useTranslation } from '@/lib/i18n/react';

export function ChatReadFailure({ error, retry, pending, copyKey = 'view.messagesFailed' }: {
  error: unknown;
  retry: () => void;
  pending: boolean;
  copyKey?: string;
}) {
  const { t } = useTranslation('teamchat');
  return <div role="alert" className="m-3 flex flex-wrap items-center gap-3 text-xs text-red-600">
    <span>{localizedErrorMessage(error, 'teamchat', copyKey)}</span>
    <button type="button" className="btn btn-secondary min-h-11 min-w-11" disabled={pending} onClick={retry}>{t('retry')}</button>
  </div>;
}
